var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarbefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.749,
    height: 15.749,
    viewBox: "0 0 15.749 15.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar-lines_1_",
    "data-name": "calendar-lines (1)",
    d: "M12.468,1.312h-.656V.656a.656.656,0,1,0-1.312,0v.656H5.25V.656a.656.656,0,0,0-1.312,0v.656H3.281A3.285,3.285,0,0,0,0,4.593v7.874a3.285,3.285,0,0,0,3.281,3.281h9.187a3.285,3.285,0,0,0,3.281-3.281V4.593A3.285,3.285,0,0,0,12.468,1.312ZM3.281,2.625h9.187a1.971,1.971,0,0,1,1.969,1.969V5.25H1.312V4.593A1.971,1.971,0,0,1,3.281,2.625Zm9.187,11.812H3.281a1.971,1.971,0,0,1-1.969-1.969V6.562H14.436v5.906A1.971,1.971,0,0,1,12.468,14.436Zm0-5.25a.656.656,0,0,1-.656.656H3.937a.656.656,0,1,1,0-1.312h7.874A.656.656,0,0,1,12.468,9.187ZM7.874,11.812a.656.656,0,0,1-.656.656H3.937a.656.656,0,1,1,0-1.312H7.218A.656.656,0,0,1,7.874,11.812Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarbefore);
export default __webpack_public_path__ + "static/media/calendarbefore.5d27869d0051e8e0096b5beedf084ae3.svg";
export { ForwardRef as ReactComponent };